import {FormattedMessage, defineMessages} from 'react-intl';
import {view} from '@sail/ui';

import {TextRow} from '../Chat/Row/TextRow';

const messages = defineMessages({
  requestACallExplanationMessage: {
    id: 'conversations_ui.supportWidget.rac.requestACallExplanaitonMessage',
    description:
      'Instructions shown to the user in the conversation log after they successfully submit a RAC request',
    defaultMessage:
      'We’re on it. You should receive a call at the number listed in the card above in the next 5 minutes. The agent will provide you with an identification code, and then ask you for your code shown above. Keep this chat open until you receive the call.',
  },
  requestACallExplanationMessageAnonymous: {
    id: 'conversations_ui.supportWidget.rac.requestACallExplanationMessageAnonymous',
    description:
      'Instructions shown to anonymous users in the conversation log after they successfully submit a RAC request (no PIN codes shown)',
    defaultMessage:
      'We’re on it. You should receive a call at the number listed in the card above in the next 5 minutes. Keep this chat open until you receive the call.',
  },
});

type Props = {
  name: string;
  phoneNumber: string;
  message: string;
  isAnonymous?: boolean;
};

export const ConfirmationInline = ({
  name,
  phoneNumber,
  message,
  isAnonymous,
}: Props) => {
  return (
    <view.div
      css={{
        stack: 'y',
        gap: 'large',
      }}
    >
      <view.div>
        <view.div
          className="uh-conversations-button-options-message-row"
          data-message-type="user"
          css={{
            margin: 'small',
          }}
        >
          <TextRow
            position="end"
            body={`${name}
            ${phoneNumber}
            ${message}`}
          />
        </view.div>
      </view.div>

      {/* eslint-disable-next-line react/style-prop-object */}
      <TextRow body="" style="info">
        <FormattedMessage
          {...(isAnonymous
            ? messages.requestACallExplanationMessageAnonymous
            : messages.requestACallExplanationMessage)}
        />
      </TextRow>
    </view.div>
  );
};
